var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"ml-4 m4-4 mt-2 mr-4 mb-2"},_vm._l((_vm.introContent),function(paragraph,index){return _c('p',{key:index},[_vm._v(" "+_vm._s(paragraph)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }